import {Card} from "react-bootstrap";
import UserSettingsTransferForm from "./UserSettingsTransferForm";
import {useContext} from "react";
import {AuthContext} from "../../context/AuthContext";
import UserSettingsXmlFeedForm from "./UserSettingsXmlFeedForm";

export default function UserSettings() {

    const {currentUser} = useContext(AuthContext)

    return (
        <>
            {(currentUser?.settings && currentUser.settings['global.isXmlFeedActive'] === '1') &&
            <>
                <Card className="mb-3">
                    <Card.Body>
                        <Card.Title>Cбор позиций</Card.Title>
                        <UserSettingsXmlFeedForm/>
                    </Card.Body>
                </Card>
            </>
            }
            <Card>
                <Card.Body>
                    <Card.Title>Возобновление переезда</Card.Title>
                    <UserSettingsTransferForm/>
                </Card.Body>
            </Card>
        </>
    )
}
